export const LIST_APP_RATING = 'LIST_APP_RATING'
export const DELETE_APP_RATING = 'DELETE_APP_RATING'
